import { render, staticRenderFns } from "./DivC.vue?vue&type=template&id=65d7ef73&scoped=true"
import script from "./DivC.vue?vue&type=script&lang=js"
export * from "./DivC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d7ef73",
  null
  
)

export default component.exports